(function() {
    'use strict';

    angular.module("product")
        .controller('ProductOptionPricesInQuantityCreate', ProductOptionPricesInQuantityCreate);

    ProductOptionPricesInQuantityCreate.$inject = ['currentQuantity', 'product', 'options', 'selectedGroups', '$uibModalInstance', 'lodashService', 'productoptionpricePermissionsConst'];

    function ProductOptionPricesInQuantityCreate(currentQuantity, product, options, selectedGroups, $uibModalInstance, lodashService, productoptionpricePermissionsConst) {
        var self = this;

        var selected_options = lodashService.flatten(selectedGroups.map(function(group) {
            return group.options;
        }));

        self.optionRows = selected_options.map(function(item) {
            var price = null;
            if (currentQuantity.prices) {
                price = currentQuantity.prices[item.option];
            }

            var option_obj = lodashService.find(options, function(opt) {
                return opt.pk === item.option;
            });

            return {
                price: price ? price : 0,
                pk: item.option,
                product_option: item.option,
                option_label: option_obj.label,
                quantity: currentQuantity.pk
            };
        });
        self.optionsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            isEditable: false
        }, {
            title: 'Opcja',
            value: 'option_label',
            type: 'text',
            isEditable: false
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true
        }];
        self.modelPermissions = productoptionpricePermissionsConst;

        self.ok = ok;
        self.onOptionEdit = onOptionEdit;

        function ok() {
            $uibModalInstance.close();
        }

        function onOptionEdit(row) {
            if (!currentQuantity.prices) {
                currentQuantity.prices = {};
            }
            currentQuantity.prices[row.product_option] = row.price;
        }
    }
})();
